export enum LoadingStatus {
    Idle = 'idle',
    Pending = 'pending',
    Completed = 'completed',
    Failed = 'failed',
}
